import { render, staticRenderFns } from "./RecipeNutritionBreakdown.vue?vue&type=template&id=2fc7f776&scoped=true"
import script from "./RecipeNutritionBreakdown.vue?vue&type=script&lang=ts"
export * from "./RecipeNutritionBreakdown.vue?vue&type=script&lang=ts"
import style0 from "./RecipeNutritionBreakdown.vue?vue&type=style&index=0&id=2fc7f776&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc7f776",
  null
  
)

export default component.exports